export enum Locale {
  EN_US = 'EN_US',
  ES_US = 'ES_US'
}
